import styled from 'styled-components';

export const Wrapper = styled.div`
    overflow-wrap: break-word;

    .header {
        margin: 0;
    }
`;
